/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DesignWell
 */
export interface DesignWell {
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof DesignWell
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof DesignWell
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  designWellId: string | null;
  /**
   *
   * @type {object}
   * @memberof DesignWell
   */
  wellFunctions: object;
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  height: string | null;
  /**
   * Point coordinates as string
   * @type {string}
   * @memberof DesignWell
   */
  wellPos: string | null;
  /**
   *
   * @type {DesignWellGeometryPubliclyAvailableEnum}
   * @memberof DesignWell
   */
  geometryPubliclyAvailable: DesignWellGeometryPubliclyAvailableEnum | null;
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  maximumWellDepth: string | null;
  /**
   *
   * @type {DesignWellMaximumWellDepthPubliclyAvailableEnum}
   * @memberof DesignWell
   */
  maximumWellDepthPubliclyAvailable: DesignWellMaximumWellDepthPubliclyAvailableEnum | null;
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  maximumWellCapacity: string | null;
  /**
   *
   * @type {DesignWellRelativeTemperatureEnum}
   * @memberof DesignWell
   */
  relativeTemperature: DesignWellRelativeTemperatureEnum | null;
  /**
   *
   * @type {object}
   * @memberof DesignWell
   */
  designScreen: object;
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  installation: string;
  /**
   *
   * @type {string}
   * @memberof DesignWell
   */
  dataOwner: string;
}

/**
 * @export
 */
export const DesignWellGeometryPubliclyAvailableEnum = {
  Ja: "ja",
  Nee: "nee",
} as const;
export type DesignWellGeometryPubliclyAvailableEnum =
  (typeof DesignWellGeometryPubliclyAvailableEnum)[keyof typeof DesignWellGeometryPubliclyAvailableEnum];

/**
 * @export
 */
export const DesignWellMaximumWellDepthPubliclyAvailableEnum = {
  Ja: "ja",
  Nee: "nee",
} as const;
export type DesignWellMaximumWellDepthPubliclyAvailableEnum =
  (typeof DesignWellMaximumWellDepthPubliclyAvailableEnum)[keyof typeof DesignWellMaximumWellDepthPubliclyAvailableEnum];

/**
 * @export
 */
export const DesignWellRelativeTemperatureEnum = {
  Koud: "koud",
  Warm: "warm",
  Onbekend: "onbekend",
} as const;
export type DesignWellRelativeTemperatureEnum =
  (typeof DesignWellRelativeTemperatureEnum)[keyof typeof DesignWellRelativeTemperatureEnum];

/**
 * Check if a given object implements the DesignWell interface.
 */
export function instanceOfDesignWell(value: object): value is DesignWell {
  if (
    (!("designWellId" in (value as Record<string, any>)) &&
      !("design_well_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designWellId"] === undefined &&
      (value as Record<string, any>)["design_well_id"] === undefined)
  )
    return false;
  if (
    (!("wellFunctions" in (value as Record<string, any>)) &&
      !("well_functions" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["wellFunctions"] === undefined &&
      (value as Record<string, any>)["well_functions"] === undefined)
  )
    return false;
  if (!("height" in value) || value["height"] === undefined) return false;
  if (
    (!("wellPos" in (value as Record<string, any>)) &&
      !("well_pos" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["wellPos"] === undefined &&
      (value as Record<string, any>)["well_pos"] === undefined)
  )
    return false;
  if (
    (!("geometryPubliclyAvailable" in (value as Record<string, any>)) &&
      !("geometry_publicly_available" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["geometryPubliclyAvailable"] === undefined &&
      (value as Record<string, any>)["geometry_publicly_available"] === undefined)
  )
    return false;
  if (
    (!("maximumWellDepth" in (value as Record<string, any>)) &&
      !("maximum_well_depth" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumWellDepth"] === undefined &&
      (value as Record<string, any>)["maximum_well_depth"] === undefined)
  )
    return false;
  if (
    (!("maximumWellDepthPubliclyAvailable" in (value as Record<string, any>)) &&
      !("maximum_well_depth_publicly_available" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumWellDepthPubliclyAvailable"] === undefined &&
      (value as Record<string, any>)["maximum_well_depth_publicly_available"] === undefined)
  )
    return false;
  if (
    (!("maximumWellCapacity" in (value as Record<string, any>)) &&
      !("maximum_well_capacity" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumWellCapacity"] === undefined &&
      (value as Record<string, any>)["maximum_well_capacity"] === undefined)
  )
    return false;
  if (
    (!("relativeTemperature" in (value as Record<string, any>)) &&
      !("relative_temperature" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["relativeTemperature"] === undefined &&
      (value as Record<string, any>)["relative_temperature"] === undefined)
  )
    return false;
  if (
    (!("designScreen" in (value as Record<string, any>)) &&
      !("design_screen" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designScreen"] === undefined &&
      (value as Record<string, any>)["design_screen"] === undefined)
  )
    return false;
  if (!("installation" in value) || value["installation"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function DesignWellFromJSON(json: any): DesignWell {
  return DesignWellFromJSONTyped(json, false);
}

export function DesignWellFromJSONTyped(json: any, ignoreDiscriminator: boolean): DesignWell {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    designWellId: json["design_well_id"],
    wellFunctions: json["well_functions"],
    height: json["height"],
    wellPos: json["well_pos"],
    geometryPubliclyAvailable: json["geometry_publicly_available"],
    maximumWellDepth: json["maximum_well_depth"],
    maximumWellDepthPubliclyAvailable: json["maximum_well_depth_publicly_available"],
    maximumWellCapacity: json["maximum_well_capacity"],
    relativeTemperature: json["relative_temperature"],
    designScreen: json["design_screen"],
    installation: json["installation"],
    dataOwner: json["data_owner"],
  };
}

export function DesignWellToJSON(json: any): DesignWell {
  return DesignWellToJSONTyped(json, false);
}

export function DesignWellToJSONTyped(
  value?: Omit<DesignWell, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    design_well_id: value["designWellId"],
    well_functions: value["wellFunctions"],
    height: value["height"],
    well_pos: value["wellPos"],
    geometry_publicly_available: value["geometryPubliclyAvailable"],
    maximum_well_depth: value["maximumWellDepth"],
    maximum_well_depth_publicly_available: value["maximumWellDepthPubliclyAvailable"],
    maximum_well_capacity: value["maximumWellCapacity"],
    relative_temperature: value["relativeTemperature"],
    design_screen: value["designScreen"],
    installation: value["installation"],
    data_owner: value["dataOwner"],
  };
}
